module.exports = __webpack_public_path__ + "media/images/heart-outline-5d7a4deaa3cddcc9fa01a47502940a1e.svg";